(() => {
  'use strict';

  const instances = new WeakMap();

  const rootsIn = (scope) => {
    const roots = [];
    if (scope?.matches?.('[data-ld-pdp-engine]')) roots.push(scope);
    if (scope?.querySelectorAll) roots.push(...scope.querySelectorAll('[data-ld-pdp-engine]'));
    return roots;
  };

  const mount = (root) => {
    if (instances.has(root)) return;
    const modules = window.LDPDPModules || {};
    const motion = modules.mountMotion?.(root);
    const productForm = modules.mountProductForm?.(root);
    const webgl = modules.mountWebGL?.(root, motion);
    const editor = modules.mountEditor?.(root, motion);

    root.classList.add('is-ready');
    instances.set(root, {
      destroy() {
        editor?.destroy?.();
        webgl?.destroy?.();
        productForm?.destroy?.();
        motion?.destroy?.();
        root.classList.remove('is-ready');
      }
    });
  };

  const init = (scope = document) => rootsIn(scope).forEach(mount);
  const destroy = (scope) => {
    rootsIn(scope).forEach((root) => {
      instances.get(root)?.destroy?.();
      instances.delete(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  window.LDPDPExperienceEngine = { init, destroy };
})();
